import React, { FC } from "react";
import "./Footer.css";
import FooterNav from "./components/footer-nav/FooterNav";
import logo from "../../assets/OneLifeLogo_Final.svg";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import JumpToTop from "../../helpers/jumpToTop";

const Footer: FC = () => {
  const navigate = useNavigate()
  const goHome = () => {
    navigate('/')
}
  return (
    <footer className="footer">

      <div className="footerColumns">
      <div className="footer-logo" onClick={goHome} >
        <img src={logo} alt="Logo"  />
      </div>
        <div className="aboutColumn">

          <p className="aboutText">
          One Life Funding is a private equity lender primarily serving the SouthEast region of the United States started and backed by principals who have expertise in billions of dollars worth of transactions in a wide variety of domains including banking and investment.
          </p>
        </div>
          <h3>Types of Loans</h3>
        <div className="footer-loan-types">
          <ul>
            <li>Term Loans</li>
            <li>Mezzanine Loans</li>
            <li>Bridge Loans</li>
            <li>Construction Loans</li>
            <li>Renovation Loans</li>
            <li>Soft Secured Loans</li>
          </ul>
        </div>
          <h3>Navigation</h3>
        <div>
          <FooterNav />
        </div>
          <h3>Contact Us</h3>
        <div className="contactCard">
          <p>One Life Equity Fund LP.</p>
          <p>81 Lincoln St.</p>
          <p>Hampton, VA 23669-3521</p>
          <p>Phone : <a href="tel:757-218-9952">757-218-9952</a> </p>
          <p>Email: <a href="mailto:info@onelifefunding.com">info@onelifefunding.com</a></p>
        </div>
      </div>
      <div className="footer-container">
        <div className="footer-links">
          <NavLink onClick={JumpToTop} to="/terms-and-conditions" className="footer-link highlighted">
            Terms & Conditions
          </NavLink>
          <NavLink onClick={JumpToTop} to="/privacy-policy" className="footer-link">
            Privacy Policy
          </NavLink>
        </div>
        <div className="footer-copy">
          <p>Copyright © 2024 One Life Equity Fund.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
